// 比赛信息
export function eventInfo() {
    let info = {};
    info.eventCode = 240987;
    info.channel = "teacher";
    info.showSignUpBtn = false; // 是否显示注册按钮
    info.autoReg = false; // 自动报名开关：true-登录后，若未报名，可选择组别报名；
    info.bannerLinks = [{
        //     name: "排行榜",
        //     link: "https://ix.icode.org.cn/rankBoard?eventCode=240987"
        // }, {
        name: "ICode学习平台",
        link: "https://home.icode.org.cn"
    }];
    info.showSchoolRank = false; // 是否显示学校榜
    info.cameraTest = false;
    info.needPsw = false;
    info.timeLimit = false;
    info.needVip = false; //true-只有VIP用户才能参加，false-所有用户都可以参加
    info.orgIds = [] // 可以参加活动的机构id，为空时所有机构都可参加
    info.rankTitle = "ICode国际青少年编程竞赛教师学习平台";
    info.notice = "欢迎使用ICode国际青少年编程竞赛教师学习平台！";
    info.bgFileUrl = "" // 自定义背景图链接地址，若不使用自定义背景则为""
    info.bgIndex = 7; // 默认背景图编号：0-10
    info.pageText = {
        title: "ICode国际青少年编程竞赛<br>教师学习平台", // 主标题
        subTitle: "", // 副标题
        // 下方单位信息
        orgList: [
            "主办单位：ICODE中国区组委会",
            "协办单位：立乐教育科技（上海）有限公司"
        ]
    };
    info.eventGameList = [{
        name: "图形化编程", // 组别名称
        id: 24098701, // 比赛ID
        mode: 0, // 比赛模式：0-积木，1-Python
        minGrade: 0,
        maxGrade: 13,
    }, {
        name: "Python编程",
        id: 24098711,
        mode: 1,
        minGrade: 0,
        maxGrade: 13,
    }];
    return info;
}


// WEBPACK FOOTER //
// ./src/components/contest/teacher/eventConfig.js